import BasicModel from '../basic/BasicModel'
export default {
  findNewsList(vm, params, listener) {
    let action = 'news/findNewsList.action'
    BasicModel.get(vm, action, params, listener)
  },
  addNews(vm, params, listener) {
    let action = 'news/addNews.action'
    BasicModel.post(vm, action, params, listener)
  },
  editNews(vm, params, listener) {
    let action = 'news/editNews.action'
    BasicModel.post(vm, action, params, listener)
  },
  getNews(vm, params, listener) {
    let action = 'news/getNews.action'
    BasicModel.get(vm, action, params, listener)
  },
  deleteNews(vm, params, listener) {
    let action = 'news/deleteNews.action'
    BasicModel.post(vm, action, params, listener)
  }
}
